<template>
  <div class="keyboard">
    <c-toolbar type="AM RGB 65" />
    <div class="keyboard-panel">
      <div class="light-index">
        <a-radio-group
          :value="profile65GameBoy.lightIndex"
          size="large"
          @change="onLightIndexSelect"
        >
          <a-radio-button :value="5"> {{ $t("light.name") }} 1 </a-radio-button>
          <a-radio-button :value="6"> {{ $t("light.name") }} 2 </a-radio-button>
          <a-radio-button :value="7"> {{ $t("light.name") }} 3 </a-radio-button>
        </a-radio-group>
      </div>
      <c-led-strip-65-game-boy
        class="lights"
        :isPlaying="true"
        :brightness="brightness"
        :speed="speed"
        :frames="frames"
        :frameIndex="frameIndex"
        :selectedIndexes="[]"
        disabled
        @click="goLight"
      />
      <c-keyboard-65-game-boy
        class="c-keyboard"
        :layer="layer"
        :layerIndex="0"
        :selectedIndex="-2"
        disabled
        @click="goKeyboard"
      />
    </div>
    <div class="buttons">
      <div class="profile">{{ profile65GameBoy.fileName }}</div>
      <label class="upload" for="file">
        <i class="iconfont iconupload" />
        {{ $t("upload") }}
        <input
          id="file"
          type="file"
          @change="onUpload"
          accept=".json"
          @click="type = 'upload'"
        />
      </label>
      <div class="download" @click="selectVisible = true">
        <i class="iconfont icondownload" />
        {{ $t("download") }}
        json
      </div>
      <a-modal
        v-model="selectVisible"
        width="80vw"
        :footer="null"
        :centered="true"
        :closable="false"
        :maskClosable="false"
        :maskStyle="{ background: '#1c1c1c' }"
      >
        <div class="c-select">
          <div class="title">
            {{ $t("selectVersion.select") }}
          </div>
          <md-checkbox v-model="led1" class="checkbox">
            {{ $t("selectVersion.led") }} 1
          </md-checkbox>
          <md-checkbox v-model="led2" class="checkbox">
            {{ $t("selectVersion.led") }} 2
          </md-checkbox>
          <md-checkbox v-model="led3" class="checkbox">
            {{ $t("selectVersion.led") }} 3
          </md-checkbox>
          <md-checkbox v-model="inSwitch1" class="checkbox">
            {{ $t("selectVersion.inSwitch") }} 1
          </md-checkbox>
          <md-checkbox v-model="inSwitch2" class="checkbox">
            {{ $t("selectVersion.inSwitch") }} 2
          </md-checkbox>
          <md-checkbox v-model="inSwitch3" class="checkbox">
            {{ $t("selectVersion.inSwitch") }} 3
          </md-checkbox>
          <md-checkbox v-model="layout" class="checkbox">
            {{ $t("selectVersion.layout") }}
          </md-checkbox>
          <div class="buttons">
            <md-button class="button" @click="selectVisible = false">
              {{ $t("cancel") }}
            </md-button>
            <md-button class="button" @click="onDownload">
              {{ $t("yes") }}
            </md-button>
          </div>
        </div>
      </a-modal>
    </div>
    <div class="in-switch-led">
      <div class="item" @click="goLight" v-if="!inLoader">
        <i class="iconfont iconarrow-right" />
        <div v-html="$t('light.name')"></div>
      </div>
      <div class="item" @click="goKeyboard">
        <i class="iconfont iconarrow-right" />
        <div v-html="$t('index.keyboardTitle')"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { download, deepCopy } from "@/utils";

export default {
  name: "Keyboard65GameBoy",
  data() {
    return {
      brightness: 100,
      speed: 100,
      frames: [],
      frameIndex: 0,
      selectVisible: false,
      led1: true,
      led2: true,
      led3: true,
      inSwitch1: true,
      inSwitch2: true,
      inSwitch3: true,
      layout: true,
    };
  },
  computed: {
    ...mapState("loader", {
      inLoader: "inLoader",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profile65GameBoy"]),
    layer() {
      return this.profile65GameBoy.data.key_layer.layer_data[0].layer;
    },
    layerNum() {
      return this.profile65GameBoy.data.key_layer.layer_num;
    },
  },
  methods: {
    initLight() {
      const lightEffects = this.profile65GameBoy.data.page_data;
      const lightEffect = deepCopy(
        lightEffects[this.profile65GameBoy.lightIndex]
      );
      this.brightness = lightEffect.lightness;
      this.speed = lightEffect.speed_ms;
      this.frames = lightEffect.frames.frame_data;
      this.frameIndex = 0;
    },
    onLightIndexSelect(e) {
      this.$store
        .dispatch("profile65GameBoy/setLightIndex", e.target.value)
        .then(() => {
          this.initLight();
        });
    },
    onUpload(e) {
      const file = e.target.files[0];
      if (file) {
        new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onerror = reject;
          fileReader.onload = (e) => {
            try {
              const data = JSON.parse(e.target.result);
              if (
                data &&
                data.product_info &&
                data.product_info.product_id === "RGB_65"
              ) {
                resolve(data);
              } else {
                reject();
              }
            } catch (error) {
              reject(error);
            }
          };
          fileReader.readAsText(file);
        })
          .then((data) => {
            this.layerIndex = 0;
            if (data.origin_keyframes) {
              data.page_data[5].keyframes = data.origin_keyframes[0];
              data.page_data[6].keyframes = data.origin_keyframes[1];
              data.page_data[7].keyframes = data.origin_keyframes[2];
            }
            this.$store.dispatch("profile65GameBoy/setData", data);
            this.$store.dispatch(
              "profile65GameBoy/setFileName",
              file.name.split(".")[0]
            );
            this.$store.dispatch("loader/syncMacroKey", {
              macro_key: data.macro_key,
              original_key: "",
            });
            e.target.value = null;
          })
          .catch(() => {
            e.target.value = null;
            this.$info({
              title: this.$t("index.fileErrorInfo"),
              width: "8.4rem",
              okText: this.$t("yes"),
              cancelText: this.$t("cancel"),
              centered: true,
            });
          });
      }
    },
    onDownload() {
      const data = deepCopy(this.profile65GameBoy.data);
      let length = 0;
      data.origin_keyframes = [];
      data.page_data[5].frames.valid = this.led1 ? 1 : 2;
      data.page_data[5].keyframes.valid = this.inSwitch1 ? 1 : 2;
      data.origin_keyframes[0] = deepCopy(data.page_data[5].keyframes);
      length = data.page_data[5].keyframes.frame_data.length;
      if (length > 100) {
        for (let index = length - 100; index >= 0; index--) {
          data.page_data[5].keyframes.frame_data.splice(
            Math.floor((length / (length - 100)) * index),
            1
          );
        }
        data.page_data[5].keyframes.frame_data = data.page_data[5].keyframes.frame_data.map(
          (item, index) => ({
            ...item,
            frame_index: index,
          })
        );
        data.page_data[5].keyframes.frame_num = 100;
      }
      data.page_data[6].frames.valid = this.led2 ? 1 : 2;
      data.page_data[6].keyframes.valid = this.inSwitch2 ? 1 : 2;
      data.origin_keyframes[1] = deepCopy(data.page_data[6].keyframes);
      length = data.page_data[6].keyframes.frame_data.length;
      if (length > 100) {
        for (let index = length - 100; index >= 0; index--) {
          data.page_data[6].keyframes.frame_data.splice(
            Math.floor((length / (length - 100)) * index),
            1
          );
        }
        data.page_data[6].keyframes.frame_data = data.page_data[6].keyframes.frame_data.map(
          (item, index) => ({
            ...item,
            frame_index: index,
          })
        );
        data.page_data[6].keyframes.frame_num = 100;
      }
      data.page_data[7].frames.valid = this.led3 ? 1 : 2;
      data.page_data[7].keyframes.valid = this.inSwitch3 ? 1 : 2;
      data.origin_keyframes[2] = deepCopy(data.page_data[7].keyframes);
      length = data.page_data[7].keyframes.frame_data.length;
      if (length > 100) {
        for (let index = length - 100; index >= 0; index--) {
          data.page_data[7].keyframes.frame_data.splice(
            Math.floor((length / (length - 100)) * index),
            1
          );
        }
        data.page_data[7].keyframes.frame_data = data.page_data[7].keyframes.frame_data.map(
          (item, index) => ({
            ...item,
            frame_index: index,
          })
        );
        data.page_data[7].keyframes.frame_num = 100;
      }
      data.key_layer.valid = this.layout ? 1 : 2;

      const fileName = (
        this.profile65GameBoy.fileName + "-RGB-65.json"
      ).replace(/-65.+65/, "-65");
      if (this.inLoader) {
        data.page_num = 0;
        data.page_data = [];
        this.$store.dispatch("loader/downloadFile", {
          name: fileName.replace("-RGB-65.json", "-RGB-65-KEY.json"),
          json: data,
        });
      } else {
        const file = new Blob([JSON.stringify(data)]);
        download(file, fileName);
      }
      this.selectVisible = false;
    },
    goLight() {
      this.$router.push(this.$paths.light65GameBoy);
    },
    goKeyboard() {
      this.$router.push(this.$paths.keyboard65GameBoy);
    },
  },
  mounted() {
    this.initLight();
  },
};
</script>
<style lang="scss" scoped>
.keyboard {
  min-height: inherit;
  text-align: center;
  color: #ffffff;

  .keyboard-panel {
    @include flex-center;
    flex-direction: column;
    margin-top: 50px;
    margin-bottom: 50px;

    .light-index {
      width: 1320px;
      margin-bottom: 20px;
      text-align: left;
    }

    .lights {
      width: 1320px;
      cursor: pointer;
      z-index: 1;
      margin-bottom: -226px;
    }

    .c-keyboard {
      width: 1320px;
      cursor: pointer;
      z-index: 0;
    }
  }

  .buttons {
    @include flex-center;

    .profile {
      @include nowrap;
      width: 140px;
      height: 42px;
      line-height: 42px;
      border: 1px solid $active-color;
      border-right: 0 !important;
      border-radius: 4px 0 0 4px;
      color: $active-color;
      font-size: 12px;
      letter-spacing: 0.2em;
      text-align: left;
      padding: 0 20px;
    }

    .upload {
      @include button;
      width: 180px;
      border-radius: 0 4px 4px 0;

      input {
        display: none;
      }
    }

    .download {
      @include button;
      width: 280px;
      margin-left: 100px;
    }
  }

  .in-switch-led {
    position: fixed;
    right: 20px;
    bottom: 200px;
    font-size: 20px;

    .item {
      @include flex-center;
      justify-content: flex-start;
      width: 200px;
      cursor: pointer;

      + .item {
        margin-top: 20px;
      }

      &:hover {
        color: $primary-color;
      }
    }

    i {
      width: 54px;
      height: 54px;
      line-height: 54px;
      display: block;
      background: $primary-color;
      color: #ffffff;
      border-radius: 10px;
      margin-right: 20px;
      font-size: 22px;
      padding-left: 5px;
      text-align: center;
    }
  }
}

.c-select {
  @include flex-center;
  width: 900px;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .title {
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .checkbox {
    width: 230px;
    font-size: 20px;
    color: #ffffff;
    margin: 0 auto 30px auto;
  }

  .buttons {
    @include flex-center;
    width: 100%;
    margin-top: 10px;

    .button {
      width: 150px;
      height: 53px;
      background-color: $active-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }

  &.cn .checkbox {
    width: 160px;
  }
}
</style>
